import lodashIsArray from 'lodash/fp/isArray';

export const PROPERTY_TYPE_OPTION_HOME = 'Homes';
export const PROPERTY_TYPE_OPTION_TOWNHOMES_DUPLEXES = 'Townhomes/Duplexes';
export const PROPERTY_TYPE_OPTION_APARTMENT = 'Apartments';

export const PROPERTY_TYPE_OPTION_VALUE_HOUSE = 'House';
export const PROPERTY_TYPE_OPTION_VALUE_QUADRIPLEX = 'Quadriplex';
export const PROPERTY_TYPE_OPTION_VALUE_DUPLEX = 'Duplex';
export const PROPERTY_TYPE_OPTION_VALUE_TRIPLEX = 'Triplex';
export const PROPERTY_TYPE_OPTION_VALUE_MOBILE_HOME = 'Mobile Home';
export const PROPERTY_TYPE_OPTION_VALUE_MANUFACTURED_HOME = 'Manufactured Home';
export const PROPERTY_TYPE_OPTION_VALUE_TOWNHOUSE = 'Townhouse';
export const PROPERTY_TYPE_OPTION_VALUE_SINGLE_FAMILY_ATTACHED = 'Single Family Attached';
export const PROPERTY_TYPE_OPTION_VALUE_APARTMENT = 'Apartment';
export const PROPERTY_TYPE_OPTION_VALUE_APARTMENT_COMPLEX = 'Apartment Complex';
export const PROPERTY_TYPE_OPTION_VALUE_APARTMENT_CONDOMINIUM = 'Condominium';

export const PROPERTY_TYPES_SINGLE_FAMILY = [
  PROPERTY_TYPE_OPTION_VALUE_HOUSE,
  PROPERTY_TYPE_OPTION_VALUE_MOBILE_HOME,
  PROPERTY_TYPE_OPTION_VALUE_MANUFACTURED_HOME,
  PROPERTY_TYPE_OPTION_VALUE_TOWNHOUSE,
];

export const RENTLINX_PROPERTY_TYPE_APARTMENT = 'Apartments';
export const RENTLINX_PROPERTY_TYPE_HOUSE = 'House';
export const RENTLINX_PROPERTY_TYPE_CONDO = 'Condo';
export const RENTLINX_PROPERTY_TYPE_DUPLEX = 'Duplex';
export const RENTLINX_PROPERTY_TYPE_TRIPLEX = 'Triplex';
export const RENTLINX_PROPERTY_TYPE_QUADRIPLEX = '4plex';
export const RENTLINX_PROPERTY_TYPE_SENIOR = 'Senior';
export const RENTLINX_PROPERTY_TYPE_SUBSIDIZED = 'Subsidized';
export const RENTLINX_PROPERTY_TYPE_TOWNHOUSE = 'Townhouse';
export const RENTLINX_PROPERTY_TYPE_FLAT = 'Flat';
export const RENTLINX_PROPERTY_TYPE_COOPERATIVE = 'Cooperative';
export const RENTLINX_PROPERTY_TYPE_CORPORATE_SUITE = 'CorporateSuite';
export const RENTLINX_PROPERTY_TYPE_HIGH_RISE = 'HighRise';
export const RENTLINX_PROPERTY_TYPE_ROOM_FOR_RENT = 'Room For Rent';
export const RENTLINX_PROPERTY_TYPE_ASSISTED_LIVING = 'AssistedLiving'; // Senior Housing
export const RENTLINX_PROPERTY_TYPE_GARDEN_STYLE = 'GardenStyle'; // Garden Style (1-4 stories)
export const RENTLINX_PROPERTY_TYPE_MID_RISE = 'MidRise'; // Mid Rise (5-8 stories)
export const RENTLINX_PROPERTY_TYPE_MOBILE_HOME = 'Mobile'; // Mobile Home
export const RENTLINX_PROPERTY_TYPE_SPECIAL_NEEDS = 'SpecialNeeds'; // Special Needs Housing

export const PROPERTY_TYPE_OPTION_VALUE_TO_RENTLINX_PROPERTY_TYPE_MAPPING = {
  [PROPERTY_TYPE_OPTION_VALUE_HOUSE]: RENTLINX_PROPERTY_TYPE_HOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_QUADRIPLEX]: RENTLINX_PROPERTY_TYPE_QUADRIPLEX,
  [PROPERTY_TYPE_OPTION_VALUE_DUPLEX]: RENTLINX_PROPERTY_TYPE_DUPLEX,
  [PROPERTY_TYPE_OPTION_VALUE_TRIPLEX]: RENTLINX_PROPERTY_TYPE_TRIPLEX,
  [PROPERTY_TYPE_OPTION_VALUE_MOBILE_HOME]: RENTLINX_PROPERTY_TYPE_MOBILE_HOME,
  [PROPERTY_TYPE_OPTION_VALUE_MANUFACTURED_HOME]: RENTLINX_PROPERTY_TYPE_HOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_TOWNHOUSE]: RENTLINX_PROPERTY_TYPE_TOWNHOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_SINGLE_FAMILY_ATTACHED]: RENTLINX_PROPERTY_TYPE_DUPLEX,
  [PROPERTY_TYPE_OPTION_VALUE_APARTMENT]: RENTLINX_PROPERTY_TYPE_APARTMENT,
  [PROPERTY_TYPE_OPTION_VALUE_APARTMENT_COMPLEX]: RENTLINX_PROPERTY_TYPE_APARTMENT,
  [PROPERTY_TYPE_OPTION_VALUE_APARTMENT_CONDOMINIUM]: RENTLINX_PROPERTY_TYPE_CONDO,
};

export const ZILLOW_PROPERTY_TYPE_CONDO = 'CONDO';
export const ZILLOW_PROPERTY_TYPE_HOUSE = 'HOUSE';
export const ZILLOW_PROPERTY_TYPE_TOWNHOUSE = 'TOWNHOUSE';

export const PROPERTY_TYPE_OPTION_VALUE_TO_ZILLOW_PROPERTY_TYPE_MAPPING = {
  [PROPERTY_TYPE_OPTION_VALUE_HOUSE]: ZILLOW_PROPERTY_TYPE_HOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_QUADRIPLEX]: ZILLOW_PROPERTY_TYPE_HOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_DUPLEX]: ZILLOW_PROPERTY_TYPE_HOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_TRIPLEX]: ZILLOW_PROPERTY_TYPE_HOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_MOBILE_HOME]: ZILLOW_PROPERTY_TYPE_HOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_MANUFACTURED_HOME]: ZILLOW_PROPERTY_TYPE_HOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_TOWNHOUSE]: ZILLOW_PROPERTY_TYPE_TOWNHOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_SINGLE_FAMILY_ATTACHED]: ZILLOW_PROPERTY_TYPE_HOUSE,
  [PROPERTY_TYPE_OPTION_VALUE_APARTMENT]: ZILLOW_PROPERTY_TYPE_CONDO,
  [PROPERTY_TYPE_OPTION_VALUE_APARTMENT_COMPLEX]: ZILLOW_PROPERTY_TYPE_CONDO,
  [PROPERTY_TYPE_OPTION_VALUE_APARTMENT_CONDOMINIUM]: ZILLOW_PROPERTY_TYPE_CONDO,
};

export const PROPERTY_TYPE_OPTIONS_PARTNER = [
  PROPERTY_TYPE_OPTION_VALUE_HOUSE,
  PROPERTY_TYPE_OPTION_VALUE_APARTMENT,
  PROPERTY_TYPE_OPTION_VALUE_APARTMENT_CONDOMINIUM,
  PROPERTY_TYPE_OPTION_VALUE_QUADRIPLEX,
  PROPERTY_TYPE_OPTION_VALUE_TRIPLEX,
  PROPERTY_TYPE_OPTION_VALUE_DUPLEX,
  PROPERTY_TYPE_OPTION_VALUE_TOWNHOUSE,
];

export const PROPERTY_TYPE_OPTIONS_VALUES = [
  PROPERTY_TYPE_OPTION_VALUE_HOUSE,
  PROPERTY_TYPE_OPTION_VALUE_QUADRIPLEX,
  PROPERTY_TYPE_OPTION_VALUE_DUPLEX,
  PROPERTY_TYPE_OPTION_VALUE_TRIPLEX,
  PROPERTY_TYPE_OPTION_VALUE_MOBILE_HOME,
  PROPERTY_TYPE_OPTION_VALUE_MANUFACTURED_HOME,
  PROPERTY_TYPE_OPTION_VALUE_TOWNHOUSE,
  PROPERTY_TYPE_OPTION_VALUE_SINGLE_FAMILY_ATTACHED,
  PROPERTY_TYPE_OPTION_VALUE_APARTMENT,
  // NOTE(@d-oliveros):
  //  Although this value exists when pulling data from the MLS,
  //  we don't want to consider this value as part of the property type option items.
  //
  // PROPERTY_TYPE_OPTION_VALUE_APARTMENT_COMPLEX,
  PROPERTY_TYPE_OPTION_VALUE_APARTMENT_CONDOMINIUM,
];

export const PROPERTY_TYPE_OPTION_TO_MAPPING_REALSAVVY_VALUES = {
  [PROPERTY_TYPE_OPTION_HOME]: [PROPERTY_TYPE_OPTION_VALUE_HOUSE],
  [PROPERTY_TYPE_OPTION_TOWNHOMES_DUPLEXES]: [
    PROPERTY_TYPE_OPTION_VALUE_QUADRIPLEX,
    PROPERTY_TYPE_OPTION_VALUE_DUPLEX,
    PROPERTY_TYPE_OPTION_VALUE_TRIPLEX,
    PROPERTY_TYPE_OPTION_VALUE_MOBILE_HOME,
    PROPERTY_TYPE_OPTION_VALUE_MANUFACTURED_HOME,
    PROPERTY_TYPE_OPTION_VALUE_TOWNHOUSE,
    PROPERTY_TYPE_OPTION_VALUE_SINGLE_FAMILY_ATTACHED,
  ],
  [PROPERTY_TYPE_OPTION_APARTMENT]: [
    PROPERTY_TYPE_OPTION_VALUE_APARTMENT,
    PROPERTY_TYPE_OPTION_VALUE_APARTMENT_COMPLEX,
    PROPERTY_TYPE_OPTION_VALUE_APARTMENT_CONDOMINIUM,
  ],
};

export const getPropertyTypeValues = (properTypeOptions) => {
  const propertyType = (lodashIsArray(properTypeOptions)
    ? properTypeOptions
    : [properTypeOptions]
  ).reduce((memo, propertyTypeOption) => {
    (PROPERTY_TYPE_OPTION_TO_MAPPING_REALSAVVY_VALUES[propertyTypeOption] || []).forEach((pt) => {
      memo.push(pt);
    });
    return memo;
  }, []);

  return propertyType;
};
